// extracted by mini-css-extract-plugin
export default {"content":"Backup-module__content","buttonWrapper":"Backup-module__buttonWrapper","footerButton":"Backup-module__footerButton","modalSticker":"Backup-module__modalSticker"};